import type { NextPage } from "next";
import dynamic from "next/dynamic";

/*
 * data fetchのsuspense化がSSRで動作しないため、CSRを強制する
 * https://itandi.esa.io/posts/5474
 */
const NoSSR = dynamic<Empty>(
	() =>
		import("../../components/pages/vendors").then((mod) => mod.PageComponent),
	{
		ssr: false
	}
);

const Page: NextPage = () => <NoSSR />;

export default Page;
